import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { useCallback } from 'react';
import { DragDropFilesCard } from './DragDropFilesCard';
import { toast } from 'react-toastify';
import Documents from '../../../services/Documents';
import DocumentsInterface from '../../../interfaces/DocumentsInterface';
import { FilteredOptionsInterface } from '../../../entities/FilteredOptions';
import { DocumentsStateManager } from './DocumentsStateManager';

type DragDropProps = {
  documentsState: DocumentsStateManager;
};

export const DragDropFiles = ({ documentsState }: DragDropProps) => {
  const hashFolderId = documentsState.state?.hash?.replace('#', '');

  const updatePositions = async (
    filteredOptions: FilteredOptionsInterface,
    idFile: string,
    _: number,
    hoverIndex: number,
  ) => {
    if (documentsState.hasDocumentEditPermission()) {
      const filterFolderIdPosition = {
        field: 'documentsFoldersId',
        operation: '=',
        value: hashFolderId,
      };

      const filterSchool = {
        field: 'schoolId',
        operation: 'hash',
        value: documentsState.state?.school?.value,
      };

      filteredOptions.filters = [filterFolderIdPosition, filterSchool];

      const resultPositions = await Documents(documentsState.state.token || '').listForPosition(filteredOptions);
      const dataPositions: DocumentsInterface[] = resultPositions.data;
      const hoverIndexPosition = hoverIndex + 1;
      let countPositions = 1;
      // let index = 1;
      dataPositions.map((row: any) => {
        if (row.id == idFile || row.idAsInteger === idFile) {
          handleSubmit(row.id, hoverIndex + 1);
        } else {
          if (countPositions == hoverIndexPosition) {
            countPositions = countPositions + 1;
          }
          handleSubmit(row.id, countPositions);
        }

        countPositions = countPositions + 1;
        // index++;
      });
    }
  };

  const handleSubmit = async (id: string, position: number) => {
    const body = {
      position: position,
    };

    try {
      if (documentsState.hasDocumentEditPermission()) {
        await Documents(documentsState.state.token || '').updatePositions(id, body);
      }
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Create error!');
      toast.error(message);
    }
  };

  const moveCard = useCallback((dragIndex: number, hoverIndex: number, idFile: string) => {
    const updateCards = (prevCards: DocumentsInterface[]) => {
      return update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex] as DocumentsInterface],
        ],
      });
    };
    const updatedCard = updateCards(documentsState.state.documentsCards);
    documentsState.setDocumentsCards(updatedCard);
    updatePositions(documentsState.state.filteredOptions, idFile, dragIndex, hoverIndex);
  }, []);

  const renderCard = useCallback((card: DocumentsInterface, index: number) => {
    return (
      <DragDropFilesCard key={index} card={card} moveCard={moveCard} index={index} documentsState={documentsState} />
    );
  }, []);

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }} className="row">
          {documentsState.state.documentsCards?.map((card, i) => renderCard(card, i))}
        </div>
      </DndProvider>
    </>
  );
};
